export const initialState = {
  cart: [],
  totalCartItems: 0,
  user: null,
  selectedCartItems: [],
  totalSelectedCartItems: 0,
  itemsAreSelected: false,
};

export const getCartTotal = (cart) => {
  let cartTotal = cart?.reduce(
    (amount, product) => product.item.price * product.quantity + amount,
    0
  );
  cartTotal = Number(cartTotal.toFixed(2));
  return cartTotal;
};

export const getSelectedItemsTotal = (selectedCartItems) => {
  let selectedItemsTotal = selectedCartItems?.reduce(
    (amount, product) => product.item.price * product.quantity + amount,
    0
  );
  selectedItemsTotal = Number(selectedItemsTotal.toFixed(2));
  return selectedItemsTotal;
};

const reducer = (state, action) => {
  let newState;
  switch (action.type) {
    case 'ADD_TO_CART':
      if (action.cart !== undefined) {
        newState = {
          ...state,
          cart: action.cart,
          totalCartItems: action.totalCartItems,
          selectedCartItems: action.selectedCartItems,
          totalSelectedCartItems: action.totalSelectedCartItems,
        };
      } else {
        newState = {
          ...state,
          cart: [
            ...state.cart,
            {
              item: action.item,
              quantity: 1,
            },
          ],
          selectedCartItems: [
            ...state.cart,
            {
              item: action.item,
              quantity: 1,
            },
          ],
          totalCartItems: action.totalCartItems,
          totalSelectedCartItems: action.totalSelectedCartItems,
        };
      }
      return newState;
    case 'SET_SELECTED_CART_ITEMS':
      newState = {
        ...state,
        selectedCartItems: state.cart,
        totalSelectedCartItems: state.totalCartItems,
      };
      return newState;
    case 'EMPTY_CART':
      return {
        ...state,
        cart: [],
        totalCartItems: 0,
      };
    case 'EMPTY_SELECTED_CART_ITEMS':
      return {
        ...state,
        selectedCartItems: [],
        totalSelectedCartItems: 0,
      };
    case 'EMPTY_BOTH_CARTS':
      return {
        ...state,
        cart: [],
        totalCartItems: 0,
        selectedCartItems: [],
        totalSelectedCartItems: 0,
      };
    case 'REMOVE_FROM_CART':
      let newCart = [...state.cart];

      let cartIndex = state.cart.findIndex(
        (cartItem) => cartItem.item.id === action.id
      );

      const quantity = newCart[cartIndex].quantity;

      if (cartIndex >= 0) {
        newCart.splice(cartIndex, 1);
      } else {
        alert("Can't remove product");
      }
      return {
        ...state,
        cart: newCart,
        totalCartItems: state.totalCartItems - quantity,
      };
    case 'SET_USER':
      return {
        ...state,
        user: action.user,
      };
    case 'CHANGE_QUANTITY_CHECKOUT':
      if (action.item) {
        return {
          ...state,
          cart: action.cart,
          selectedCartItems: [
            ...state.selectedCartItems,
            {
              item: action.item,
              quantity: action.quantity,
            },
          ],
          totalCartItems: state.totalCartItems + action.quantityChange,
          totalSelectedCartItems: state.totalCartItems + action.quantityChange,
        };
      } else {
        return {
          ...state,
          cart: action.cart,
          selectedCartItems: action.selectedCartItems,
          totalCartItems: state.totalCartItems + action.quantityChange,
          totalSelectedCartItems: state.totalCartItems + action.quantityChange,
        };
      }
    case 'ADD_SELECTED_CART_ITEM':
      return {
        ...state,
        selectedCartItems: [
          ...state.selectedCartItems,
          {
            item: action.item,
            quantity: action.quantity,
          },
        ],
        totalSelectedCartItems: action.totalSelectedCartItems,
      };
    case 'REMOVE_SELECTED_CART_ITEM':
      let newSelectedCartItems = [...state.selectedCartItems];

      let selectedCartItemsIndex = state.selectedCartItems.findIndex(
        (cartItem) => cartItem.item.id === action.id
      );

      if (selectedCartItemsIndex >= 0) {
        newSelectedCartItems.splice(selectedCartItemsIndex, 1);
      } else {
        alert("Can't remove product");
      }
      return {
        ...state,
        selectedCartItems: newSelectedCartItems,
        totalSelectedCartItems: state.totalSelectedCartItems - action.quantity,
      };
    case 'ITEMS_SELECTED':
      return {
        ...state,
        itemsAreSelected: true,
      };
    case 'ITEMS_NOT_SELECTED':
      return {
        ...state,
        itemsAreSelected: false,
      };
    default:
      return state;
  }
};

export default reducer;
